import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  successMessages: [],
  errorMessages: [],
  infoMessages: []
};

const pageNotificationsSlice = createSlice({
  name: "pageNotifications",
  initialState: INITIAL_STATE,
  reducers: {
    setErrorMessage(state, action) {
      Object.keys(action.payload).forEach(message => {
        state.errorMessages.push(action.payload[message]);
      });
    },
    setSuccessMessage(state, action) {
      Object.keys(action.payload).forEach(message => {
        state.successMessages.push(action.payload[message]);
      });
    },
    setInfoMessage(state, action) {
      Object.keys(action.payload).forEach(message => {
        state.infoMessages.push(action.payload[message]);
      });
    },
    setClearMessage(state, _) {
      state.successMessages = [];
      state.errorMessages = [];
    }
  }
});

export const { setErrorMessage, setSuccessMessage, setInfoMessage, setClearMessage } =
  pageNotificationsSlice.actions;
export default pageNotificationsSlice;
